import React from "react";
import "./questionnaireAnswers.css";

const QuestionnaireAnswers = ({ questionnaireAnswers }) => {
	return (
		<div className="company-profile-student-details-section">
			{questionnaireAnswers ? (
				Object.keys(questionnaireAnswers).map((question, qNum) => {
					return (
						<div className="company-profile-student-details-region">
							<div className="company-profile-student-details-label">
								Q{qNum + 1} - {question}
							</div>
							<div className="company-profile-student-details-value">
								{questionnaireAnswers[question]
									.split("\n")
									.map((line, index) =>
										line ? <div key={index}>{line}</div> : <br key={index} />
									)}
							</div>
						</div>
					);
				})
			) : (
				<div>Auto screening data not available</div>
			)}
		</div>
	);
};

export default QuestionnaireAnswers;
